import { apiMethodContext } from "libs/utils/http/builder/UrlConfig";
import { CloudConsoleClient } from "libs/utils/http/client/HttpClient";
import { APIResource, APIMethod } from "libs/utils/http/decorator/UrlDecorator";
import { from } from "rxjs";
import { IdentityApplication } from "../../services/ApplicationService";
import { IdentityApplicationCreateRequest } from "pages/home/apis/services/ApiService";




@APIResource(CloudConsoleClient, "publisher/v2/applications")
class ApplicationServiceFactory {

    @APIMethod("/deployment/:deploymentId/throttling")
    public createApiThrottling(deploymentId: string, requestBody: any) {
      return from(
        CloudConsoleClient.post<any>(apiMethodContext(arguments), requestBody, {
          params: {
            deploymentId
          },
        }).then((value) => value.data)
      );
    }

    @APIMethod("/:resourceAppId/versions",  {
        options: {
            noTrailingSlash: true
        }
    })
    public getAllVersions(resourceAppId: string) {
      return from(
        CloudConsoleClient.get<any>(apiMethodContext(arguments), {
          params: {
            resourceAppId          },
        }).then((value) => value.data)
      );
    }


         @APIMethod("", {
            options: {
                noTrailingSlash: true
            }
         })
          public getAllApplication(gatewayName: string, applicationType: string) {
              return from(CloudConsoleClient.get<IdentityApplication[]>(apiMethodContext(arguments),{
                params: {
                  gatewayName,
                  includeEmailAddress: true,
                  type: applicationType
                }
                
              }).then(value => value.data));
          }

           @APIMethod("", {
                  options: {
                      noTrailingSlash: true
                  }
              })
                 public createApplication(teamId: Record<string, string>, request?: IdentityApplicationCreateRequest, ) {
                   return from(
                     CloudConsoleClient.post<any>(apiMethodContext(arguments), request, {
                       params: {
                          ...teamId
                       },
                     }).then((value) => value.data)
                   );
                 }

}

const ApplicationService = new ApplicationServiceFactory();

export default ApplicationService;